<template>
	<div class="rebag">
		<TwoHeader></TwoHeader>

		<div class="bgcontent">
			<div class="box-card">
				<LeftNav></LeftNav>
				<!-- 	<div class="download" @click="godown" style="color:blue;text-decoration:underline;padding:40px;">附件：《考生健康承诺书》下载</div> -->
				<h2 class="printbtn" v-if="show">
					<button class="yubutton no-print" v-print="printObj" style="cursor: pointer;"
						@click="printstuts">打印</button>
				</h2>
				<div class="fl" v-if="show">
					<div id="baoright1" >
						<div v-for="(item,index) in msg" :key="index">
							<img :src="$store.state.host+item"  />
						</div>
					</div>
				</div>
				<div class="fl" v-if="!show">
					<h2 class="yutitle" style="padding-top: 50px;text-align: center;width: 1020px;">没有查询到准考证相关信息</h2>
				</div>

			</div>
		</div>
		<TowFooTer></TowFooTer>
	</div>
</template>

<script>
	import {
		loadZkzById,
		printCard
	} from "@/api/api";
	import TwoHeader from '../components/common/twoheader.vue'
	import LeftNav from '../components/common/leftnav.vue'
	import TowFooTer from '../components/common/towfooter.vue'
	import {
		mapState
	} from 'vuex'
	export default {
		name: "printzheng",
		components: {
			TwoHeader,
			LeftNav,
			TowFooTer
		},
		data() {
			return {
				printObj: {
					id: "baoright1",
					popTitle: '准考证打印',
					extraCss: '',
					extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
				},
				pisitioninfo: {},
				cardinfo: {},
				msg: "",
				show: true
				// baseURL: 'http://localhost:8013',

			}
		},
		computed: {
			...mapState({
				token: 'token',
				userexaminfo: 'userexaminfo',
				examid: 'examid',
				baseUrl: 'baseUrl',
			})
		},
		methods: {
			godown() {
				let a = document.createElement('a')
				a.href = "考生健康承诺书.doc"
				a.click();
			},
			godown1() {
				let a = document.createElement('a')
				a.href = "服务基层项目人员审核表.docx"
				a.click();
			},
			printstuts() {
				printCard({}, this.token).then(() => {

				})
			}
		},
		created() {
			const loading = this.$loading({
				lock: true,
				text: '拼命加载中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			setTimeout(() => {
				loading.close();
			}, 2000);
			loadZkzById({
				"examinationId": this.examid
			}, this.$store.state.token).then(res => {
				console.log(res.data)
				if (res.data.code == 500) {
					this.show = false
				}
				this.msg = res.data.data
			})
		}

	}
</script>

<style scoped="">
	.fl {
		float: right;
	}

	#baoright1 img{
		width: 1020px;
	}

	.rebag {
		background: url('../assets/denglu.png');
		background-size: cover;

	}

	.bright {
		float: right;
	}

	.brightp {
		line-height: 130px;
		color: #FFFFFF !important;
		font-size: 16px;
		margin-left: 20px;
		list-style: none;
	}

	.yubutton {
		padding: 3px 18px;
	}

	.brightp i {
		font-size: 20px;
	}

	.bgcontent {
		margin-top: 40px;
	}

	.el-card {
		border: none;
	}

	.box-card {
		margin: 0 auto;
		width: 1200px;
		margin: 0 auto;
		height: auto;
		overflow: hidden;
		margin-bottom: 50px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		background-color: #ECF4FF;
		position: relative;
	}

	.baoimeg {
		width: 180px;
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		display: block;
		height: 64px;
		line-height: 64px;
		color: #ffffff;
	}

	.baoright {
		float: left;
		width: 979px;
		background-color: #ffffff;
		padding: 20px;
		padding-bottom: 80px;
	}

	.biaoti2 {
		float: right;
		margin-top: -40px;
		margin-right: 30px;
	}

	.printbtn {
		position: absolute;
		top: 10px;
		right: 20px;
		z-index: 100;
		width: 100px;
		height: 40px;


	}

	.yudiv {
		width: 100%;
		text-align: center;
		margin: 0 auto;
	}

	.yutitle {
		font-size: 28px;
		color: #000000 !important;
	}

	.yutowtitle {
		margin-top: -10px;
	}

	.wenzip {
		text-align: left;
		margin-left: 30px;
		margin-right: 16px;
		font-size: 18px;
		line-height: 24px;
		text-indent: 36px;
	}

	table {
		width: 950px;
		text-align: center;
		/* 表边框合并  两个单元格之间的边框进行合并 */
		border-collapse: collapse;
		margin: 0 auto;
	}

	table td {
		border-width: 1px;
		border-style: solid;
		background-color: white;
		height: 40px;
		width: 100px;
		border: 1px #000000 solid;
	}

	table th {
		background-color: white;
		height: 40px;
		width: 100px;
	}

	.ycbianhao {
		font-weight: bold;
		width: 86px;
		font-size: 22px;
	}

	.yutext {
		text-align: left;
		padding-left: 20px;
		font-size: 22px;
	}

	.toptable {
		margin-top: 30px;
	}

	.divbut {
		margin-top: 20px;
	}

	.divbut button {
		width: 100px;
		height: 32px;
		margin-right: 10px;
	}

	/*去除页眉页脚*/
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 3mm;
		/* this affects the margin in the printer settings */
	}

	html {
		background-color: #FFFFFF;
		margin: 0;
		/* this affects the margin on the html before sending to printer */
	}

	body {
		border: solid 1px blue;
		margin: 10mm 15mm 10mm 15mm;
		/* margin you want for the content */
	}

	/*去除页眉页脚*/
</style>
